export default __webpack_public_path__ + "static/media/logo.33b0fa50.png";